class OiProjectCarousel {
    private carousel: HTMLElement;
    private slides: NodeListOf<HTMLElement>;
    private prevBtns: NodeListOf<HTMLButtonElement>;
    private nextBtns: NodeListOf<HTMLButtonElement>;
    private currentIndex = 0;
    private autoplayInterval: number | null = null;
    private readonly intervalDuration = 5000; // 5 seconds between slides

    constructor(carousel: HTMLElement) {
        this.carousel = carousel;
        this.slides = this.carousel.querySelectorAll<HTMLElement>('.project-slide');
        this.prevBtns = this.carousel.querySelectorAll<HTMLButtonElement>('.prev-slide');
        this.nextBtns = this.carousel.querySelectorAll<HTMLButtonElement>('.next-slide');
        this.initializeCarousel();
        this.startAutoplay();
        this.enableTouchSwipeIfMobile();
    }

    private initializeCarousel(): void {
        this.slides.forEach((slide, i) => {
            slide.style.opacity = i === 0 ? '1' : '0';
            slide.style.pointerEvents = i === 0 ? 'auto' : 'none';
        });

        const showSlide = (index: number) => {
            if (this.slides[this.currentIndex]) {
                this.slides[this.currentIndex].style.opacity = '0';
                this.slides[this.currentIndex].style.pointerEvents = 'none';
            }
            if (this.slides[index]) {
                this.slides[index].style.opacity = '1';
                this.slides[index].style.pointerEvents = 'auto';
            }
            this.currentIndex = index;
        };

        const nextSlide = () => {
            this.resetAutoplay();
            showSlide((this.currentIndex + 1) % this.slides.length);
        };

        const prevSlide = () => {
            this.resetAutoplay();
            showSlide((this.currentIndex - 1 + this.slides.length) % this.slides.length);
        };

        this.prevBtns.forEach(btn => btn.addEventListener('click', prevSlide));
        this.nextBtns.forEach(btn => btn.addEventListener('click', nextSlide));

        this._showSlide = showSlide;
        this._showNext = nextSlide;
        this._showPrev = prevSlide;
    }

    private startAutoplay(): void {
        this.autoplayInterval = window.setInterval(() => {
            const nextIndex = (this.currentIndex + 1) % this.slides.length;
            this.slides[this.currentIndex].style.opacity = '0';
            this.slides[this.currentIndex].style.pointerEvents = 'none';
            this.slides[nextIndex].style.opacity = '1';
            this.slides[nextIndex].style.pointerEvents = 'auto';
            this.currentIndex = nextIndex;
        }, this.intervalDuration);
    }

    private resetAutoplay(): void {
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval);
            this.startAutoplay();
        }
    }

    private _showSlide: (index: number) => void;
    private _showNext: () => void;
    private _showPrev: () => void;

    private enableTouchSwipeIfMobile(): void {
        if (window.innerWidth <= 768) {
            let startX = 0;
            let endX = 0;

            this.carousel.addEventListener('touchstart', (e: TouchEvent) => {
                startX = e.touches[0].clientX;
            });

            this.carousel.addEventListener('touchmove', (e: TouchEvent) => {
                endX = e.touches[0].clientX;
            });

            this.carousel.addEventListener('touchend', () => {
                const dx = startX - endX;

                if (dx > 50) {
                    this._showNext();
                } else if (dx < -50) {
                    this._showPrev();
                }
            });
        }
    }
}

export default OiProjectCarousel;